import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";
import type { Id } from "../../convex/_generated/dataModel";
import { useConvexMutation } from "./use-convex-mutation";

export function useKidMissions(childId: string) {
  const data = useQuery(
    api.parent.missions.getForChild,
    childId ? { childId: childId as Id<"players"> } : "skip"
  );
  return { data, isLoading: data === undefined };
}

export function useClaimMission() {
  return useConvexMutation(api.parent.missions.claimMission);
}

export function useConfirmMission() {
  return useConvexMutation(api.parent.missions.confirmMission);
}

export function useRejectMission() {
  return useConvexMutation(api.parent.missions.rejectMission);
}

export function usePendingMissionConfirmations() {
  const data = useQuery(api.parent.missions.getPendingConfirmations);
  return { data, isLoading: data === undefined };
}
